// const themes = [
//   {
//     name: 'Granite',
//     alpha: {
//       color: '#d8dbd5',
//       legend: '#1f1c1a'
//     },
//     modifier: {
//       color: '#a8aaa6',
//       legend: '#1f1c1a'
//     },
//     delete: {
//       color: '#4088c3',
//       legend: '#1f1c1a'
//     },
//     space: {
//       color: '#d8dbd5'
//     },
//     esc: {
//       color: '#ca3b33',
//       legend: '#1f1c1a'
//     },
//     numberRow: {
//       color: '#d8dbd5',
//       legend: '#1f1c1a'
//     },
//     caseColor: '#fff'
//   },
//   {
//     name: 'Cobalt2',
//     alpha: {
//       color: '#1a3c53',
//       legend: '#ddd972'
//     },
//     modifier: {
//       color: '#1a3c53',
//       legend: '#1f90fc'
//     },
//     delete: {
//       color: '#204b68',
//       legend: '#69d810'
//     },
//     space: {
//       color: '#193b53'
//     },
//     esc: {
//       color: '#facd33',
//       legend: '#193b53'
//     },
//     numberRow: {
//       color: '#204b68',
//       legend: '#6de011'
//     },
//     caseColor: '#111'
//   }
// ]

const layout = {
  keys: [
    { name: 'esc', group: 'esc', size: 1, legends: ['\u238B', 'esc'] },
    { name: '1', group: 'numberRow', size: 1, legends: ['1', '1!'] },
    { name: '2', group: 'numberRow', size: 1, legends: ['2', '2@'] },
    { name: '3', group: 'numberRow', size: 1, legends: ['3', '3#'] },
    { name: '4', group: 'numberRow', size: 1, legends: ['4', '4$'] },
    { name: '5', group: 'numberRow', size: 1, legends: ['5', '5%'] },
    { name: '6', group: 'numberRow', size: 1, legends: ['6', '6^'] },
    { name: '7', group: 'numberRow', size: 1, legends: ['7', '7&'] },
    { name: '8', group: 'numberRow', size: 1, legends: ['8', '8*'] },
    { name: '9', group: 'numberRow', size: 1, legends: ['9', '9('] },
    { name: '0', group: 'numberRow', size: 1, legends: ['0', '0)'] },
    { name: '-', group: 'numberRow', size: 1, legends: ['-', '-_'] },
    { name: '+', group: 'numberRow', size: 1, legends: ['=', '+='] },
    {
      name: 'backspace',
      group: 'delete',
      size: 2,
      legends: ['\u232b', 'backspace']
    },
    { name: 'tab', group: 'modifier', size: 1.5, legends: ['\u21b9', 'tab'] },
    { name: 'q', group: 'alpha', size: 1, legends: ['q'] },
    { name: 'w', group: 'alpha', size: 1, legends: ['w'] },
    { name: 'e', group: 'alpha', size: 1, legends: ['e'] },
    { name: 'r', group: 'alpha', size: 1, legends: ['r'] },
    { name: 't', group: 'alpha', size: 1, legends: ['t'] },
    { name: 'y', group: 'alpha', size: 1, legends: ['y'] },
    { name: 'u', group: 'alpha', size: 1, legends: ['u'] },
    { name: 'i', group: 'alpha', size: 1, legends: ['i'] },
    { name: 'o', group: 'alpha', size: 1, legends: ['o'] },
    { name: 'p', group: 'alpha', size: 1, legends: ['p'] },
    { name: '[', group: 'alpha', size: 1, legends: ['['] },
    { name: ']', group: 'alpha', size: 1, legends: [']'] },
    { name: '\\', group: 'alpha', size: 1.5, legends: ['\\'] },
    { name: 'caps', group: 'modifier', size: 2, legends: ['\u21ea', 'caps'] },
    { name: 'a', group: 'alpha', size: 1, legends: ['a'] },
    { name: 's', group: 'alpha', size: 1, legends: ['s'] },
    { name: 'd', group: 'alpha', size: 1, legends: ['d'] },
    { name: 'f', group: 'alpha', size: 1, legends: ['f'] },
    { name: 'g', group: 'alpha', size: 1, legends: ['g'] },
    { name: 'h', group: 'alpha', size: 1, legends: ['h'] },
    { name: 'j', group: 'alpha', size: 1, legends: ['j'] },
    { name: 'k', group: 'alpha', size: 1, legends: ['k'] },
    { name: 'l', group: 'alpha', size: 1, legends: ['l'] },
    { name: ';', group: 'alpha', size: 1, legends: [';'] },
    { name: "'", group: 'alpha', size: 1, legends: ["'"] },
    { name: 'enter', group: 'enter', size: 2, legends: ['\u23ce', 'enter'] },
    {
      name: 'shift',
      group: 'modifier',
      size: 2.5,
      legends: ['\u21E7', 'shift']
    },
    { name: 'z', group: 'alpha', size: 1, legends: ['z'] },
    { name: 'x', group: 'alpha', size: 1, legends: ['x'] },
    { name: 'c', group: 'alpha', size: 1, legends: ['c'] },
    { name: 'v', group: 'alpha', size: 1, legends: ['v'] },
    { name: 'b', group: 'alpha', size: 1, legends: ['b'] },
    { name: 'n', group: 'alpha', size: 1, legends: ['n'] },
    { name: 'm', group: 'alpha', size: 1, legends: ['m'] },
    { name: ',', group: 'alpha', size: 1, legends: [','] },
    { name: '.', group: 'alpha', size: 1, legends: ['.'] },
    { name: '/', group: 'alpha', size: 1, legends: ['/'] },
    {
      name: 'shift',
      group: 'modifier',
      size: 2.5,
      legends: ['\u21E7', 'shift']
    },
    { name: 'ctrl', group: 'modifier', size: 1.25, legends: ['ctrl'] },
    { name: 'os', group: 'modifier', size: 1.25, legends: ['os'] },
    { name: 'alt', group: 'modifier', size: 1.25, legends: ['alt'] },
    { name: 'space', group: 'space', size: 12.5, legends: ['', 'space'] },
    { name: 'alt', group: 'modifier', size: 1.25, legends: ['alt'] },
    { name: 'os', group: 'modifier', size: 1.25, legends: ['os'] },
    { name: 'fn', group: 'modifier', size: 1.25, legends: ['fn'] },
    { name: 'ctrl', group: 'modifier', size: 1.25, legends: ['ctrl'] }
  ]
}

export default layout



// WEBPACK FOOTER //
// ./src/data/data.js